import { render, staticRenderFns } from "./RecruitmentContent.vue?vue&type=template&id=0c47f83c&scoped=true"
import script from "./RecruitmentContent.vue?vue&type=script&lang=js"
export * from "./RecruitmentContent.vue?vue&type=script&lang=js"
import style0 from "./RecruitmentContent.vue?vue&type=style&index=0&id=0c47f83c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c47f83c",
  null
  
)

export default component.exports